<template>
<q-page class="main no-sticky-header">
  <div class="row justify-center">
    <q-card class="page-card col-xs-12 col-md-8">
      <common-form :action="$route('auth.notification.settings')">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Berichtinstellingen</h1>
          <p class="q-ma-none">Stel hier in bij welke berichten er een mail wordt verstuurd:</p>
          <option-group
              v-model="form.mailsettings"
              :options="possibleTypes"
              name="types[]"
              color="primary"
              label="Vink hier aan bij welke berichten er een mail wordt verstuurd"
              type="checkbox"
          />
        </q-card-section>
        <q-separator />
        <q-card-actions
            class="page-card__actions"
            align="right"
        >
          <accent-button label="Opslaan" type="submit" />
        </q-card-actions>
      </common-form>
    </q-card>
  </div>
</q-page>
</template>

<script>
import { notificationTypes } from '~HIOR/constants'

export default {
  props: {
    mailsettings: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      form: {
        mailsettings: [...this.mailsettings],
      },
    }
  },
  computed: {
    possibleTypes () {
      let settings = [
        {
          value: notificationTypes.TYPE_DAILY_REPORT,
          label: 'Stuur mij een dagelijks verslag van de berichten die ik heb ontvangen',
        },
        { value: notificationTypes.TYPE_INVITED_TO_PROJECT, label: 'Als u bent uitgenodigd voor een project' },
      ]

      if (this.$can('create-projects') || this.$can('join-projects')) {
        settings.push(
            { value: notificationTypes.TYPE_PROJECT_NEW_COMMENT, label: 'Bij een nieuw bericht' },
            { value: notificationTypes.TYPE_DISCUSSION_REPLY, label: 'Bij een reactie op een bericht' },
            { value: notificationTypes.TYPE_PROJECT_NEW_RULE, label: 'Als er een nieuwe richtlijn is toegevoegd' },
            {
              value: notificationTypes.TYPE_PROJECT_PROMOTED,
              label: 'Als het project wordt gepromoveerd naar een nieuwe fase',
            },
            { value: notificationTypes.TYPE_PROJECT_RULE_APPROVED, label: 'Als er een richtlijn is goedgekeurd' },
            { value: notificationTypes.TYPE_PROJECT_RULE_REJECTED, label: 'Als er een richtlijn is afgewezen' },
        )
      }

      if (this.$can('manage-projects') || this.$can('view-projects')) {
        settings.push(
            { value: notificationTypes.TYPE_CATEGORY_NEW_PROJECT, label: 'Een nieuw project' },
            { value: notificationTypes.TYPE_CATEGORY_NEW_COMMENT, label: 'Een bericht op een richtlijn' },
        )

        if (this.$can('manage-projects')) {
          settings.push(
              { value: notificationTypes.TYPE_CATEGORY_RULE_APPROVAL_REQUESTED, label: 'Een aanvraag tot toetsing' },
          )
        }

        if (!this.$can('create-projects') && !this.$can('join-projects')) {
          settings.push(
              { value: notificationTypes.TYPE_DISCUSSION_REPLY, label: 'Bij een reactie op een bericht' },
          )
        }
      }

      return settings
    },
  },
}
</script>
